import { hydrate, setRoutes, setRouterOptions, canonicalPathname } from 'seawomp/client';

const routes = [{"pattern":"/docs/:slug*","page":"/vercel/path0/.seawomp/client-entries/route-0-page.ts","layouts":["/vercel/path0/.seawomp/client-entries/route-2-layout.ts"]},{"pattern":"/","page":"/vercel/path0/.seawomp/client-entries/route-1-page.ts","layouts":["/vercel/path0/.seawomp/client-entries/route-3-layout.ts"]}];
setRoutes(routes);
setRouterOptions({"i18n":{"locales":["en","it"],"defaultLocale":"en","detectBrowserLocale":true},"viewTransitions":false});

function compile(pattern) {
  const parts = pattern.split('/').map((seg) => {
    if (!seg) return '';
    if (/^:(.+)\*$/.test(seg)) return '(.*)';
    if (/^:(.+)$/.test(seg)) return '([^/]+)';
    return seg.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  });
  return new RegExp('^' + parts.join('/') + '/?$');
}

async function bootstrap() {
  const p = canonicalPathname(location.pathname);
  for (const r of routes) {
    if (compile(r.pattern).test(p)) {
      for (const layout of r.layouts) await import(layout);
      await import(r.page);
      break;
    }
  }
  hydrate(document);
}

bootstrap().catch((err) => console.error('[seawomp] hydrate failed:', err));
